import { useQuery } from '@tanstack/react-query';
import { supabaseDocsService, SupabaseSupportDoc, DocsParams } from '@/services/supabaseDocsService';

export const useSupabaseDocsPosts = (params: DocsParams = {}) => {
  return useQuery({
    queryKey: ['supabase-docs-posts', params],
    queryFn: () => supabaseDocsService.fetchPosts(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useSupabaseDocsCategories = () => {
  return useQuery({
    queryKey: ['supabase-docs-categories'],
    queryFn: () => supabaseDocsService.fetchCategories(),
    staleTime: 15 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
};

export const useSupabaseDocsByAudience = (audience: string, onboardingOnly?: boolean) => {
  return useQuery({
    queryKey: ['supabase-docs-audience', audience, onboardingOnly],
    queryFn: () => supabaseDocsService.fetchByAudience(audience, onboardingOnly),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useSupabaseDocsPost = (slug: string) => {
  return useQuery({
    queryKey: ['supabase-docs-post', slug],
    queryFn: () => supabaseDocsService.fetchPost(slug),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useSupabaseDocsGrouped = (audience: string) => {
  return useQuery({
    queryKey: ['supabase-docs-grouped', audience],
    queryFn: () => supabaseDocsService.fetchByAudienceGrouped(audience),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
};

export const useSupabaseDocsSearch = (audience: string, query: string) => {
  return useQuery({
    queryKey: ['supabase-docs-search', audience, query],
    queryFn: () => supabaseDocsService.searchByAudience(audience, query),
    enabled: query.length >= 2,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
